module.exports = __webpack_public_path__ + "media/images/web/favicon/favicon-b8c4c6f57a0a34070cbf77bd8f84ced0.ico";